"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniswapV1 = void 0;
const UNISWAP_V1_EXCHANGE_ABI = require("../../abi/uniswap.v1.exchange.json");
const UNISWAP_V1_FACTORY_ABI = require("../../abi/uniswap.v1.factory.json");
const adapter_1 = __importDefault(require("./adapter"));
class UniswapV1 extends adapter_1.default {
    static getDexData(optimalRate, name) {
        return {
            name,
            srcAmount: optimalRate.srcAmount,
            destAmount: '1',
            exchange: optimalRate.data.exchange,
            factory: optimalRate.data.factory,
            deadline: 0,
            minEthBought: '1',
        };
    }
    getExchange(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (data.exchange)
                return data.exchange;
            const uniswapFactory = new this.web3Provider.eth.Contract(UNISWAP_V1_FACTORY_ABI, data.factory);
            const token = this.isETHAddress(srcToken) ? destToken : srcToken;
            return yield uniswapFactory.methods.getExchange(token).call();
        });
    }
    getExchangeContract(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const exchangeAddress = data.exchange || (yield this.getExchange(srcToken, destToken, data));
            return new this.web3Provider.eth.Contract(UNISWAP_V1_EXCHANGE_ABI, exchangeAddress);
        });
    }
    ethToTokenSwap(srcToken, destToken, data) {
        const _super = Object.create(null, {
            swap: { get: () => super.swap }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const uniswapExchange = yield this.getExchangeContract(srcToken, destToken, data);
            const deadline = data.deadline || this.getDeadline();
            const swapData = uniswapExchange.methods.ethToTokenSwapInput(data.destAmount, deadline).encodeABI();
            return _super.swap.call(this, srcToken, destToken, data, swapData, uniswapExchange._address);
        });
    }
    tokenToEthSwap(srcToken, destToken, data) {
        const _super = Object.create(null, {
            swap: { get: () => super.swap }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const uniswapExchange = yield this.getExchangeContract(srcToken, destToken, data);
            const deadline = data.deadline || this.getDeadline();
            const swapData = uniswapExchange.methods.tokenToEthSwapInput(data.srcAmount, data.destAmount, deadline).encodeABI();
            return _super.swap.call(this, srcToken, destToken, data, swapData, uniswapExchange._address);
        });
    }
    tokenToTokenSwap(srcToken, destToken, data) {
        const _super = Object.create(null, {
            swap: { get: () => super.swap }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const uniswapExchange = yield this.getExchangeContract(srcToken, destToken, data);
            const deadline = data.deadline || this.getDeadline();
            const swapData = uniswapExchange.methods.tokenToTokenSwapInput(data.srcAmount, data.destAmount, data.minEthBought, deadline, destToken).encodeABI();
            return _super.swap.call(this, srcToken, destToken, data, swapData, uniswapExchange._address);
        });
    }
}
exports.UniswapV1 = UniswapV1;
//# sourceMappingURL=uniswap-v1.js.map